<template>
    <div class="rounded-lg bg-gray-100 dark:bg-gray-700 mt-3 p-3 shadow">
        <p class="mb-4">Timeline</p>
        <draggable
            handle=".handle"
            :value="value"
            @input="data => $emit('input', data)"
            @update="updateOrder"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div v-for="(timelineEntry, index) in timeline" :key="index" class="rounded-lg bg-white dark:bg-gray-500 pt-6 pb-3 px-3 shadow mb-4 relative">

                <div class="cursor-pointer absolute right-4 top-4 mr-20 handle" title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </div>

                <svg
                    v-if="timeline?.length > minItems"
                    @click="deleteTimeline(index)"
                    class="cursor-pointer w-6 h-6 absolute right-4 top-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>

                <input-text
                    name="date_text"
                    label="* Date Text"
                    class="mb-3"
                    v-model="timelineEntry.date_text"
                    :error="errorBag?.[`${index}.date_text`]?.[0] ?? null"
                    :maxlength="255"
                />

                <input-text
                    name="heading"
                    label="* Heading"
                    class="mb-3"
                    v-model="timelineEntry.heading"
                    :error="errorBag?.[`${index}.heading`]?.[0] ?? null"
                    :maxlength="255"
                />

                <input-rich-text
                    name="text"
                    label="* Text"
                    v-model="timelineEntry.text"
                    :error="errorBag?.[`${index}.text`]?.[0] ?? null"
                    :language="language"
                />

            </div>
        </draggable>
        <Btn
            v-if="timeline?.length < maxItems"
            content="Add Timeline Entry"
            class="mt-3"
            type="button"
            @click="addTimeline"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../../stores/froala";
export default {
    name: "Timeline",
    components: {draggable},
    props: {
        value: {
            type: Array,
            required: false,
        },
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        language: Object,
    },
    data: function(){
        return {
            maxItems: 6,
            minItems: 2,
            timeline: this.value?.length ? this.value : [this.defaultEntry(), this.defaultEntry()],
            froalaStore: useFroalaStore(),
        }
    },
    mounted: function () {
        this.updateOrder();
    },
    methods: {
        defaultEntry: function(){
            return {
                date_text: null,
                heading: null,
                text: null,
            }
        },
        addTimeline: function(){
            this.timeline.push(this.defaultEntry());
            this.updateOrder();
        },
        deleteTimeline: function(index){
            this.timeline.splice(index, 1);
            this.updateOrder();
        },
        updateOrder: function(){
            const timeline = [...this.timeline];
            this.timeline = timeline.map((timeline, index) => {
                timeline.order = index;
                return timeline;
            });
            this.$emit('input', this.timeline)
        }
    },
    watch: {
        value: function(newValue){
            this.timeline = newValue;
        },
        timeline: function(newValue) {
            this.$emit('input', newValue);
        }
    }
}
</script>
